<quota-limit-modal>
    <dialog class="modal" ref="dialog" aria-labelledby="quota-limit-modal-heading">
        <div class="modal-box">
            <form method="dialog">
                <button class="absolute end-2 top-2 cursor-pointer text-xl"
                        aria-label="{locale?.t('close')}">
                    <i class="icon-clear"></i>
                </button>
            </form>

            <h3 id="quota-limit-modal-heading" class="font-bold text-lg mb-2 text-primary">
                {locale?.t('modal_processinglimit_title')}
            </h3>

            <p class="mb-2 font-semibold" if="{state.totalCredits}">
                {locale?.t('modal_processinglimit_description', { totalCredits: tools?.formatNumber(state.totalCredits) })}
            </p>

            <p class="mb-2 font-semibold" if="{!state.totalCredits}">
                {locale?.t('modal_processinglimit_description_nocredits')}
            </p>

            <div class="modal-action">
                <form method="dialog" class="flex gap-2">
                    <button class="btn text-primary rounded-lg"
                            aria-label="{locale?.t('close')}">{locale?.t('close')}</button>
                    <button if="{state.showPurchaseButton}" type="button"
                            class="btn btn-primary rounded-lg"
                            aria-label="{locale?.t('modal_processinglimit_purchasecredits')}"
                            onclick="{handlePurchaseCredits}">
                        <i class="icon-metalark-cart"></i>
                        {locale?.t('modal_processinglimit_purchasecredits')}
                    </button>
                </form>
            </div>
        </div>

        <form method="dialog" class="modal-backdrop">
            <button aria-label="{locale?.t('close')}">{locale?.t('close')}</button>
        </form>
    </dialog>

    <script>
        import { getQuotaService, getFeatureFlagService } from "../services/service-loader";

        export default {
            state: {
                totalCredits: null,
                showPurchaseButton: false
            },

            async show() {
                if (!this.state.totalCredits) {
                    const quotaService = await getQuotaService();
                    const result = await quotaService.getDetails();
                    if (result && result.totalCredits) this.state.totalCredits = result.totalCredits;
                }

                // Check if billing feature flag is enabled
                const featureFlagService = await getFeatureFlagService();
                this.state.showPurchaseButton = await featureFlagService.isEnabled('billing_ui_page');

                this.update()
                this.$('dialog').showModal()
            },

            close() {
                this.state.totalCredits = null;
                this.state.showPurchaseButton = false;
                this.$('dialog').close()
            },

            handlePurchaseCredits() {
                // Close the modal
                this.$('dialog').close()
                // Navigate to billing page
                this.tools.navigateTo('billing')
            },

            onMounted() {
                // Make globally accessible
                window.quotaLimitModal = this

                this.$('dialog').addEventListener('close', () => {
                    this.onModalClosed()
                })
            },

            onModalClosed() {
                this.state.totalCredits = null;
                this.state.showPurchaseButton = false;
                this.update()
            }
        }
    </script>
</quota-limit-modal>